import BannerTemplate from '../DefaultBanner/index'
import { report } from '@src/common/decorators'

export default class DefaultBannerFix extends BannerTemplate {
    constructor(props) {
        super(props)
        //this.campaign = props.campaign || {}
        this.hideMtgLogo() // 服务端参数控制隐藏mtg logo
    }
    
    @report([{
        proxySelector: '.jumpUrl',
        targetSelector: '.jumpUrl',
        eventName: 'click',
        action: function (...args) {
            this.platform.clickInstall(...args)
        },
        params:{
            template:"banner" // 传入模版类型
        }
    }])
    adShowed(res) {
        console.log('fix banner showed')
        this.windowStartPoint = res&&res.param || {};
    }
    /**
     * 根据服务端参数控制，隐藏mtg品牌logo，n_logo=0 隐藏，不传或为空或其他都为展示
     */
    hideMtgLogo(){
        let n_logo = macro && macro.n_logo;
        console.log("###n_logo",n_logo)
        if(n_logo!="%%n_logo%%" && parseInt(n_logo) === 0){
            if(document.getElementsByClassName("mtg")){
                for(let item of Array.from(document.getElementsByClassName("mtg"))){
                    item.setAttribute("style","display:none");
                }
            }
            if(document.getElementsByClassName("info-logo")){
                for(let item of Array.from(document.getElementsByClassName("info-logo"))){
                    item.setAttribute("style","display:none");
                }
            }
        }
    }
}